export default {
  no_image: "Loading error",
  no_image_small: "Error",
  title_photographs: "Photographs",
  dnd_content: "Drag and drop to add {entity} photos",
  dnd_quote: "Magic Mirror on the wall, which Item is the fairest of all?",
}
